import { reservationsApi } from "../../services/moksha-reservations/reservationsApi";
import { TOGGLE_LOADING } from "../types";

// Returns { ok, data } or { ok: false, message, conflicts } so the form can show the reason inline.
export const addMokshaReservation = (requestData) => {
    return async (dispatch) => {
        dispatch({ type: TOGGLE_LOADING, payload: true });
        try {
            return await reservationsApi.createReservation(requestData);
        } finally {
            dispatch({ type: TOGGLE_LOADING, payload: false });
        }
    };
};
